import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useHistory } from "react-router";
import { setProductsSearchText } from "../../../redux/actions/productActions";
const MobileSearch = () => {
  const ref = useRef();

  const history = useHistory();
  const dispatch = useDispatch();
  const { searchText } = useSelector(({ searchText }) => searchText);
  const [searchQuery, setSearchQuery] = useState(searchText);
  useEffect(() => {
    setSearchQuery(searchText);
  }, [searchText]);
  const handleRedirect = () => {
    dispatch(setProductsSearchText(searchQuery, history));
  };
  return (
    <div className="offcanvas-mobile-search-area">
      <div className="search-content">
        <div
          className="form-class"
          onKeyDown={(e) => {
            e.key === "Enter" && handleRedirect();
          }}
        >
          <input
            type="text"
            placeholder="Buscar por nombre o categoria"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button
            type="button"
            className="button-search"
            onKeyDown={(e) => {
              e.key === "Enter" && handleRedirect();
            }}
            onClick={() => handleRedirect()}
          >
            <i className="pe-7s-search" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileSearch;
